import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { CollectService } from 'src/app/services/collect.service';
import { ApplyService } from 'src/app/services/apply.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { MetadataService } from 'src/app/services/metadata.service';
import { UserService } from 'src/app/services/user.service';
import { SharedService } from 'src/app/services/shared.service';
import { GuessService } from "src/app/services/guess.service";
import { JobtitleService } from 'src/app/services/jobtitle.service';
import { NpsService } from 'src/app/services/nps.service';
import { environment } from 'src/environments/environment';
import { JobCriteria, JobSortType, JobStatus, Kind, MetadataType } from 'src/app/common';
import { Guid, Utility, setTimeout$ } from 'src/app/core/common';
import { RtwadService } from 'src/app/services/rtwad.service';

@Component({
  selector: 'app-manage-ads',
  templateUrl: './manage-ads.component.html',
  styleUrls: ['./manage-ads.component.scss']
})
export class ManageAdsComponent implements OnInit, OnDestroy {
  constructor(private route: ActivatedRoute, private router: Router, private jobService: JobService,
    private applyService: ApplyService, private spinner: SpinnerService, private store: Store, private sharedService: SharedService,
    private collectService: CollectService, private metadataService: MetadataService, private userService: UserService,
    private npsService: NpsService,
    private guessService: GuessService, private jobTitleService: JobtitleService,
		private rtwadService: RtwadService) {
  }
  JobStatus = JobStatus;
  Guid = Guid;
  Utility = Utility;
  Math = Math;
  user: any;
  Kind = Kind;
  jobTypes: any[];
  packages: any[];

  criteria = {
    q: '',
    status: JobStatus.All,
    isPaid: null,
    isExpired: null,
    jtTag: undefined,
    isDeleted: false,
    abuse: false,
    package: undefined,
    sourcename: undefined,
    sourcetype: 5,
    limit: 20,
    from: 0,
    sort: JobSortType.UpdateTime
  };
  jobs: any[];
  selected: any;
  total: number;
  jobTitles: string[];
  jobTitleTags: any[];

  imageUrl = environment.app.filesUrl;

  async ngOnInit() {
    if (!this.sharedService.isBrowser)
      return;
    this.user = this.store.selectSnapshot(state => state.auth.user);

    this.route.queryParams.pipe(switchMap(async params => {
      let newCriteria = Utility.clone(this.criteria);
      Utility.assign(newCriteria, params);
      delete newCriteria.tab;
      if (!this.jobs || Utility.isDifferent(this.criteria, newCriteria)) {
        this.criteria = newCriteria;
        await this.load();
      }

    }))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();

    setTimeout$(async () => {
      this.jobTypes = await this.metadataService.search({ Types: [MetadataType.JobType] });
      this.jobTitles = await this.jobTitleService.getAdminSuggestions('jobtitle');
      this.jobTitleTags = await this.jobTitleService.adminSearch({ UseForTagging: true });
      this.packages = await this.jobService.packages();
    }, 1);

    this.route.params.subscribe(async params => await this.loadJob(params['job'] || ''));
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async loadJob(jobId?: string) {
    if (jobId === '') {
      this.selected = undefined;
      return;
    }
    if (!jobId && !this.selected || (this.selected && this.selected.Id == jobId)) return;

    this.spinner.show('detail');
    if (jobId)
      this.selected = undefined;
    this.selected = await this.jobService.getAdmin(jobId || this.selected.Id);
    this.spinner.hide('detail');

    if (this.selected?.EmployerId)
      this.selected._employer = await this.userService.getAdmin(this.selected.EmployerId);

    this.selected._clicks = (await this.collectService.getJobClicks([this.selected.Id])) || {};
    this.selected._applies = (await this.applyService.getJobApplies([this.selected.Id])) || {};
    this.selected._nps = await this.npsService.getForAdminByItemId(this.selected.Id)
      || { Score: 0, ItemId: this.selected.Id, ItemType: 'job', ItemTitle: this.selected.Title, UserId: this.selected?.EmployerId };

  }

  async load(spin = true) {
    if (spin) { this.spinner.show('list'); }
    const result = await this.jobService.admin_search(<JobCriteria>{
      Keyword: this.criteria.q,
      Statuses: (this.criteria.status == null || this.criteria.status == JobStatus.All) ? undefined : [+this.criteria.status],
      IsPaid: this.criteria.isPaid,
      IsExpired: this.criteria.isExpired,
      TaggedJobtitleId: this.criteria.jtTag ? this.criteria.jtTag : undefined,
      IsDeleted: this.criteria.isDeleted,
      HasAbuseReport: this.criteria.abuse ? true : undefined,
      PackageKeys: this.criteria.package ? [this.criteria.package] : undefined,
      SourceType: this.criteria.sourcetype,
      SourceName: this.criteria.sourcename,
      Sort: this.criteria.sort
    }, this.criteria.from, this.criteria.limit);
    this.jobs = result.jobs;
    if (this.selected && this.jobs.find(_ => _.Id == this.selected.Id))
      Utility.assign(this.selected, this.jobs.find(_ => _.Id == this.selected.Id));
    this.total = result.total;
    if (spin) {
      this.spinner.hide('list');
      this.sharedService.scrollToTop('.jobs-list');
    }
  }

  navigate(key: string, value: any) {
    this.criteria.from = 0;
    let params = Utility.clone(this.criteria);
    params[key] = value;
    this.router.navigate([], { queryParams: params, queryParamsHandling: 'merge', relativeTo: this.route });
  }

  // async setAll(status: JobStatus) {
  //   this.spinner.show('list');
  //   this.jobs.forEach(_ => _.Status = status);
  //   await this.jobService.editAll(this.jobs);
  //   await this.load();
  //   if (window) {
  //     window.scroll(0, 0);
  //   }
  //   this.spinner.hide('list');
  // }

  async setStatus(job: any, status: JobStatus, proccess = false) {
    this.spinner.show('detail');
    await this.jobService.setStatusByAdmin(job.Id, status, {
      RejectionReason: job.RejectionReason,
      InternalCategory: job.InternalCategory
    }, proccess);
    this.spinner.hide('detail');
    if (this.selected) {
      this.selected.Status = status;
      if (status == JobStatus.Started)
        await this.loadJob();
    }

    await this.load(false);
  }

  async setIsDeleted(job: any, isDeleted: boolean) {
    this.spinner.show('detail');
    job.IsDeleted = isDeleted;
    await this.jobService.operatorSavePartial(Utility.removeEmpty(job, true));
    await this.load(false);
    this.spinner.hide('detail');
  }

  async select(jobId: string) {
    this.router.navigate([{ 'job': jobId }], { relativeTo: this.route, queryParams: { tab: 'manage' } });
  }

  @ViewChild('activityModal') activityModal: NgxSmartModalComponent;
  openActivities(job: any, dealId?: string) {
    job._dealId = dealId || Guid.Empty;

    this.setDefaultTasks(job);

    this.activityModal.open();
  }

  private setDefaultTasks(job: any) {
    if (!job.Tasks) job.Tasks = {};

    var service: any = this.jobService.services.find(_ => _.min <= job.RemainingBudget && (_.max == null || _.max > job.RemainingBudget)) || {};

    var count = job.RemainingBudget / service.step;
    if (!job.Tasks.email)
      job.Tasks.email = { Enable: service.email > 0, Count: count * service.email || 0 };
    if (!job.Tasks.sms)
      job.Tasks.sms = { Enable: service.sms > 0, Count: count * service.sms || 0 };

    if (!job.Tasks.telegram_group)
      job.Tasks.telegram_group = { Enable: service.telegram_group > 0, RecurrenceDays: 2, Count: count * service.telegram_group || 0 };
    if (!job.Tasks.telegram_post)
      job.Tasks.telegram_post = { Enable: service.telegram_post > 0, RecurrenceDays: 3, Count: count * service.telegram_post || 0 };
    if (!job.Tasks.instagram_story)
      job.Tasks.instagram_story = { Enable: service.instagram_story > 0, RecurrenceDays: 3, Count: count * service.instagram_story || 0 };

    if (!job.Tasks.instagram_post)
      job.Tasks.instagram_post = { Enable: service.instagram_post };
    if (!job.Tasks.reportage)
      job.Tasks.reportage = { Enable: service.reportage };
    if (!job.Tasks.push)
      job.Tasks.push = { Enable: service.push };
    if (!job.Tasks.twitter)
      job.Tasks.twitter = { Enable: service.twitter };
    if (!job.Tasks.linkedin)
      job.Tasks.linkedin = { Enable: service.linkedin };

    job.Tasks._processed = {};
  }

  async addActivities() {
    this.spinner.show('action');
    delete this.selected.Tasks._processed;
    await this.jobService.startTasks(this.selected.Id, this.selected.Tasks);
    this.activityModal.close();
    this.spinner.hide('action');

  }

  async clearance(job: any, invoiceAmount: number) {
    if (+invoiceAmount > job.Budget - job.InvoicedBudget) {
      alert('مبلغ فاکتور از مبلغ پرداخت شده بیشتر است');
      return;
    }
    this.spinner.show('detail');
    job = Object.assign(job, await this.jobService.clearance(job.Id, invoiceAmount));
    this.spinner.hide('detail');
  }

  decimal(value: number) { return Math.floor(value); }

  async save(job: any) {
    this.spinner.show('detail');
    await this.jobService.operatorSavePartial(Utility.removeEmpty(job, true));
    this.spinner.hide('detail');
  }

  async saveNps(nps: any) {
    let registeredNps = await this.npsService.registerAnswerByAdmin(nps);
    Utility.assign(nps, registeredNps);
  }

  async getJobTitleSuggestions(job: any) {
    job._jobTitleSuggestions = (await this.guessService.getByJob(job.Id)).list;
    if (!job.Metadata.JobTitles)
      job.Metadata.JobTitles = [];
  }

  async getReportUser(report: any) {
    report._user = await this.userService.getAdmin(report.UserId);
  }
  async tagJobTitle(job: any) {
    let res = await this.jobService.adminTagdJobTitles(job.Id);
    this.selected._metaJobTitleTags = res._metaJobTitleTags;
  }

  @ViewChild('changeOwnerModal') changeOwnerModal: NgxSmartModalComponent;
  async changeOwner(newUsername: string) {
    this.spinner.show('change-username');
    this.selected = await this.jobService.changeOwner(this.selected.Id, newUsername);
    this.spinner.hide('change-username');
    this.changeOwnerModal.close();
  }

	async convertToRtwad(jobId: string) {
		//this.spinner.show('convert-to-rtwad');
		await this.rtwadService.convertJobToReadyToWorkAd(jobId);
		//this.spinner.hide('convert-to-rtwad');
		await this.load();
	}

}
